import { useCallback, useState } from 'react';

import { useApolloClient } from 'state/graphql/hooks/use-sanity-query';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLogger } from 'state/logger';
import { useSanityGqlEndpoint } from 'utils/network';

import {
  IPersonalizedData,
  fetchPersonalizedOfferData as fetchData,
} from './utils/personalized-offers';

export const usePersonalizedOffers: () => [
  () => Promise<IPersonalizedData | null>,
  { loading: boolean }
] = () => {
  const [loading, setLoading] = useState(false);

  const client = useApolloClient();
  const uri = useSanityGqlEndpoint();
  const logger = useLogger();
  const personalizedOffersTemplateEnabled = Boolean(
    useFlag(LaunchDarklyFlag.ENABLE_PERSONALIZED_OFFERS_TEMPLATE)
  );

  const fetchPersonalizedOfferData = useCallback(async () => {
    if (!personalizedOffersTemplateEnabled) {
      return null;
    }
    let data = null;

    try {
      setLoading(true);

      data = await fetchData({ client, uri });
    } catch (e) {
      logger.error({ error: e, message: 'Error fetching personalized offers data' });
    } finally {
      setLoading(false);
    }

    return data;
  }, [setLoading, client, uri, personalizedOffersTemplateEnabled, logger]);

  return [fetchPersonalizedOfferData, { loading }];
};
